import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {TextField, TextFieldHelperText} from 'rmwc';

import * as styles from '../../styles';
import * as actions from './actions';
import {request} from '../../containers/actions';


export default class Password extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    initialState = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    };

    constructor(props, context) {
        super(props, context);
        this.state = _.clone(this.initialState);
    }

    async save() {
        try {
            this.setState({successful: false});
            this.context.store.dispatch(actions.setErrors(
                {},
                this.props.store.get('elementId'),
            ));
            const payload = {
                current_password: this.state.currentPassword,
                new_password: this.state.newPassword,
            };
            await this.context.store.dispatch(request({
                path: `/user/${this.context.user.id}/set_password/`,
                body: payload,
                method: 'PATCH',
            }));
            this.setState({...this.initialState, successful: true});
            return true;
        }
        catch (exception) {
            this.context.store.dispatch(actions.setErrors(
                exception,
                this.props.store.get('elementId'),
            ));
            this.setState({...this.initialState, successful: false});
            return false;
        }
    }

    render() {
        return <form
            style={{width: '20em', margin: 'auto'}}
            onSubmit={event => {
                if (this.state.newPassword.length < 8 || this.state.newPassword !== this.state.confirmPassword)
                    return;
                this.save.bind(this)();
                event.preventDefault();
            }}>
            {this.state.successful
                ? <div
                    style={{
                        marginTop: '.5em',
                        color: styles.successColor,
                        backgroundColor: styles.successBackColor,
                        border: `.0625em solid ${styles.successBorderColor}`,
                    }}>
                    {window.gettext('Succesffully changed password')}
                </div>
                : null
            }
            <div
                style={{
                    float: 'right',
                    clear: 'right',
                    width: '100%',
                }}>
                <TextField
                    dir='ltr'
                    rootProps={{style: {width: '100%', lineHeight: '1.2em'}}}
                    outlined
                    type='password'
                    label={window.gettext('current password')}
                    value={this.state.currentPassword}
                    onChange={
                        ({target: {value}}) => {
                            this.setState({currentPassword: value});
                        }
                    }
                />
                <div style={styles.error}>
                    {this.props.store.getIn(['errors', 'current_password'])
                        ? this.props.store.getIn(['errors', 'current_password']).map(
                            (error, index) => <li style={{display: 'block'}} key={index}>
                                * {error}
                            </li>,
                        )
                        : null
                    }
                </div>
            </div>
            <div
                style={{
                    float: 'right',
                    clear: 'right',
                    width: '100%',
                }}>
                <TextField
                    dir='ltr'
                    rootProps={{style: {width: '100%', lineHeight: '1.2em'}}}
                    outlined
                    type='password'
                    label={window.gettext('new password')}
                    value={this.state.newPassword}
                    onChange={
                        ({target: {value}}) => {
                            this.setState({newPassword: value});
                        }
                    }
                />
                <TextFieldHelperText persistent validationMsg>
                    {window.gettext('Password should not be same as your firstname, lastname, phone numbers nor national ID')}
                    <br/>
                    {window.gettext('Password should contain at least 8 characters.')}
                    <br/>
                    {window.gettext('Password can not contain only digits.')}
                </TextFieldHelperText>
                <div style={styles.error}>
                    {this.props.store.getIn(['errors', 'new_password'])
                        ? this.props.store.getIn(['errors', 'new_password']).map(
                            (error, index) => <li style={{display: 'block'}} key={index}>
                                * {error}
                            </li>,
                        )
                        : null
                    }
                    {this.state.newPassword && this.state.newPassword.length < 8
                        ? <li style={{display: 'block'}}>
                            * {window.gettext('Password should contain at least 8 characters.')}
                        </li>
                        : null
                    }
                    {this.state.newPassword && String(Number(this.state.newPassword)) === this.state.newPassword
                        ? <li style={{display: 'block'}}>
                            * {window.gettext('Password can not contain only digits.')}
                        </li>
                        : null
                    }
                </div>
            </div>
            <div
                style={{
                    float: 'right',
                    clear: 'right',
                    width: '100%',
                }}>
                <TextField
                    dir='ltr'
                    rootProps={{style: {width: '100%', lineHeight: '1.2em'}}}
                    outlined
                    type='password'
                    label={window.gettext('confirm password')}
                    value={this.state.confirmPassword}
                    onChange={
                        ({target: {value}}) => {
                            this.setState({confirmPassword: value});
                        }
                    }
                />
                <div style={styles.error}>
                    {this.state.newPassword !== this.state.confirmPassword
                        ? <li style={{display: 'block'}}>
                            * {window.gettext('Confirm password does not match with new password.')}
                        </li>
                        : null
                    }
                </div>
            </div>
            <div style={styles.dialogButtonContainer}>
                <button
                    style={styles.button}
                    type='submit'
                    disabled={this.state.newPassword.length < 8 || this.state.newPassword !== this.state.confirmPassword}>
                    {window.gettext('Apply')}
                </button>
            </div>
        </form>;
    }
}
